import React from 'react'
import { useDropzone } from 'react-dropzone'
import Loader from '@byma/shared/components/Loader'
import useAuth from '@byma/shared/hooks/useAuth'

export default function Upload({ onChange }) {
    const { token } = useAuth()
    const [loading, setLoading] = React.useState(false)

    async function onDrop(acceptedFiles) {
        acceptedFiles.forEach(async (file) => {
            setLoading(true)
            const formData = new FormData()

            formData.append('file', file);
            formData.append('upload_preset', 'd9fee5bb')

            try {
                const req = await fetch('https://api.cloudinary.com/v1_1/htkavmx5a/image/upload', {
                    method: 'POST',
                    body:formData 
                })
                const img = await req.json()
                onChange(img.secure_url)
            } catch (e) {
                console.log(e)
                console.log('Erro ao realizar upload do arquivo')
            }

            setLoading(false)
        })
    }

    const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: 'image/*',
    })


    return (
        <div {...getRootProps({className: 'dropzone focus:outline-none outline-none flex space-x-2 md:space-x-4'})}>
            {loading ? <Loader /> : (
                <div className="border-dashed border-2 dark:border-gray-400  p-6 text-center text-gray-700 dark:text-gray-200 w-full items-center justify-center flex">
                    <input {...getInputProps()} className="outline-none focus:outline-none" />
                    <p>Clique ou arraste aqui uma imagem para enviar</p>
                </div>
            )}
        </div>
    )
}
